import i18n from '@/i18n'
import validations from "@/app/validators/api/openapi";



export const getMaxChars = (api: string, apiPath: string): string => {
    return i18n.t('global.hint.maxLength', {max: validations[api][apiPath].length.maximum});
}